import { TemplateRef, Type } from '@angular/core';
import { AbstractFormFieldComponent } from '../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { FormFieldModel } from '../../../Common/PageBuilder/models/form-field.model';
import { StyleTypesApiEnum } from '@api/styles/enum/style-types-api.enum';
import { StyleStateEnum } from '@Common/PageBuilder/enums/style-state.enum';
import { TextStyleDefaultsModel } from '@Common/PageBuilder/models/text-style-defaults.model';
import { DropdownOptionModel } from '@Common/Forms/models/dropdown-option.model';

export class MonitoringTitleFieldModel implements FormFieldModel {
    property: string;
    isPrimary: boolean;
    defaults: TextStyleDefaultsModel;
    label?: string;
    showStyleState?: boolean;
    showAlignmentButtons: boolean;
    showFontSizeDropdown: boolean;
    styleType?: StyleTypesApiEnum;
    fieldComponent?: Type<AbstractFormFieldComponent>;
    description?: string;
    showBackgroundColor?: boolean;
    allowExpertMode?: boolean;
    defaultStyleStateOptions: any[] = [
        { label: 'PageBuilder.formField.styles.defaultAgilityStyle', value: StyleStateEnum.DEFAULT },
        { label: 'PageBuilder.formField.styles.custom', value: StyleStateEnum.CUSTOM }
    ];
    changeDefaultStyleStateOptions: (x: any) => DropdownOptionModel[];

    customBackgroundColorTemplate?: TemplateRef<any>;

    constructor(
        property: string,
        isPrimary: boolean = false,
        defaults: TextStyleDefaultsModel,
        label?: string,
        showStyleState: boolean = false,
        showAlignmentButtons: boolean = true,
        showFontSizeDropdown: boolean = true,
        styleType?: StyleTypesApiEnum,
        fieldComponent?: Type<AbstractFormFieldComponent>,
        description?: string,
        showBackgroundColor: boolean = true,
        allowExpertMode: boolean = true,
        defaultStyleStateOptions?: any[],
        changeDefaultStyleStateOptions?: (x: any) => DropdownOptionModel[]
    ) {
        this.property = property;
        this.isPrimary = false;
        this.defaults = defaults;
        this.label = label;
        this.showStyleState = false;
        this.showAlignmentButtons = showAlignmentButtons;
        this.showFontSizeDropdown = showFontSizeDropdown;
        this.styleType = styleType;
        this.fieldComponent = fieldComponent;
        this.description = description;
        this.showBackgroundColor = showBackgroundColor;
        this.allowExpertMode = allowExpertMode;
        if (defaultStyleStateOptions) {
            this.defaultStyleStateOptions = defaultStyleStateOptions;
        }
        this.changeDefaultStyleStateOptions = changeDefaultStyleStateOptions;
    }
}
